<template>
  <div style="position: relative">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="border-0 text-container">
        <div v-if="groups.length >0">
          <div class="title-area">
            <h1 id="what-do-you-want-to-do" class="page-title">
              {{ screentexts[4]?screentexts[4].element_text:'' }}
              <!-- <PopupBubble
                v-if="screentexts[4] && screentexts[4].element_bubbletext != '' && screentexts[4].element_bubbletext !== null"
                element_id="what-do-you-want-to-do"
                :screen_id="screen_id"
                screenelement_id="4"
                :bubbletext="screentexts[4]?screentexts[4].element_bubbletext:''"
              /> -->
            </h1>
          </div>
          <b-form-group>
            <b-form-radio
              v-model="selected"
              name="create-action"
              value="A"
            >
              <span id="existing-group">{{ screentexts[5]?screentexts[5].element_text:'Create a survey for one of my existing groups' }}</span>
              <!-- <PopupBubble
                v-if="screentexts[5] && screentexts[5].element_bubbletext != '' && screentexts[5].element_bubbletext !== null"
                class="ml-1"
                element_id="existing-group"
                :screen_id="screen_id"
                screenelement_id="5"
                :bubbletext="screentexts[5]?screentexts[5].element_bubbletext:''"
                smallbubbleclass="smallerbubble"
              /> -->
            </b-form-radio>
            <b-form-select
              v-model="group_id"
              class="select-css"
              :class="`${anon ? 'g-anon' : '' }`"
              :options="groups"
              @input="setradio('A')"
            />
          </b-form-group>
          <b-form-group>
            <b-form-radio
              v-model="selected"
              name="create-action"
              value="B"
            >
              <span id="new-group">{{ screentexts[6]?screentexts[6].element_text:'Create a survey for a new group' }}</span>
              <!-- <PopupBubble
                v-if="screentexts[6] && screentexts[6].element_bubbletext != '' && screentexts[6].element_bubbletext !== null"
                element_id="new-group"
                :screen_id="screen_id"
                screenelement_id="6"
                :bubbletext="screentexts[6]?screentexts[6].element_bubbletext:''"
                smallbubbleclass="smallerbubble"
              /> -->
            </b-form-radio>
          </b-form-group>
          <b-form-group>
            <b-form-radio
              v-model="selected"
              name="checklist-action"
              value="C"
            >
              <span id="checklist">Check if a group is a team</span>
              <!-- <PopupBubble
                v-if="screentexts[6] && screentexts[6].element_bubbletext != '' && screentexts[6].element_bubbletext !== null"
                element_id="new-group"
                :screen_id="screen_id"
                screenelement_id="6"
                :bubbletext="screentexts[6]?screentexts[6].element_bubbletext:''"
                smallbubbleclass="smallerbubble"
              /> -->
            </b-form-radio>
          </b-form-group>
        </div>
        <div v-if="groups.length == 0">
          <b-card-title>Create a new Survey</b-card-title>
          <h5>You do not yet have any groups set up.</h5>
          <h5>
            In the following pages, you will be guided in setting up your group and creating a survey for the group<br><br>
            You can check if a group is a team and suitable for the GDQ questionnaire by running the Checklist function <a href="/checklist">here</a><br><br>
            To continue, click &quot;Next&quot;
          </h5>
          <b-form-input
            v-show="false"
            v-model="selected"
            hidden
          />
        </div>
        <b-row>
    &nbsp;
        </b-row>
        <b-row />
        <b-row>
          <div class="col-12">
            <b-link
              to="/"
              class="float-left"
            >
              <b-button variant="secondary">
                &lt;<span> Back</span>
              </b-button>
            </b-link>
            <b-link
              v-if="selected == 'A' && group_id != null"
              to="/create/group/survey"
              class="float-right"
            >
              <b-button variant="primary">
                <span>Next </span>&gt;
              </b-button>
            </b-link>
            <b-link
              v-if="selected == 'B'"
              to="/create/group"
              class="float-right"
            >
              <b-button variant="primary">
                <span>Next </span>&gt;
              </b-button>
            </b-link>
            <b-button
              v-if="selected == null || (selected == 'A' && group_id == null)"
              disabled
              variant="primary"
              class="disabled float-right"
            >
              <span class="">Next </span>&gt;
            </b-button>
            <b-link
              v-if="selected == 'C'"
              to="/checklist"
              class="float-right"
            >
              <b-button variant="primary">
                <span>Next </span>&gt;
              </b-button>
            </b-link>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import PopupBubble from './PopupBubble.vue'
// import GDQList from './GDQList.vue';

export default {
  name: 'CreatePage',
  components: {
    Navbar,
    Breadcrumb
    // PopupBubble,
    //    GDQList,
  },
  data () {
    return {
      screen_id: 2,
      screentexts: [],
      group_id: null,
      selected: null,
      loading: true
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    groups: {
      get () {
        this.loading = true
        var items = this.$store.state.groups.filter(f => f.group_deleted == 0)
        var groups = [{
          value: null,
          text: 'Select group',
          disabled: true
        }]
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].group_name
          }
          groups.push(option)
        }
        this.loading = false
        return groups
      },
      set () {
        return true
      }
    }
  },
  watch: {
    groups () {
      if (this.groups.length == 0) { this.selected = 'B' } else { this.selected = 'A' }
    }
  },
  async created () {
    this.loading = true
    await this.groups_get()
    await this.screentexts_get()
    await this.$store.dispatch('group_clear')
    await this.$store.dispatch('survey_clear')
    this.loading = false
  },
  async beforeRouteLeave (to, from, next) {
    this.loading = true
    // We are going forward - save
    if (to.name == 'creategroup') {
      // Clear group in state
      await this.$store.dispatch('group_clear')
    }
    if (to.name == 'creategroupsurvey') {
      // Load group to state
      await this.$store.dispatch('group_setcurrent', this.group_id)
    }
    next()
    this.loading = false
  },
  methods: {
    groups_get: async function () {
      await this.$store.dispatch('groups_fetch')
    },
    setradio (value) {
      this.selected = value
    },
    setselect () {
      this.group_id = null
    },
    screentexts_get: async function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    }
  }
}
</script>
<style scoped>
.gg-shape-triangle {
    position: relative;
    transform: scale(var(--ggs,1));
    width: 22px;
    height: 17px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid
}
.gg-shape-triangle,
.gg-shape-triangle::before {
    display: block;
    box-sizing: border-box;
    border-right: 3px solid transparent
}
.gg-shape-triangle::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    border-left: 3px solid;
    border-top: 3px solid;
    border-bottom: 3px solid transparent;
    transform: rotate(45deg) skew(10deg,10deg);
    left: -2px;
    bottom: -13px
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
